import styled from 'styled-components';

export const Wrapper = styled('div')`
  overflow: auto;
`;

export const HeaderContainer = styled.div`
  background-color: #ffffff;
  padding: 32px 15px;

  @media (min-width: 1024px) {
    padding: 32px 180px;
  }
`;

export const ContentContainer = styled.div`
  background-color: #e5e5e5;
  padding: 35px 15px;

  @media (min-width: 1024px) {
    padding: 35px 180px;
  }
`;

export const FooterContainer = styled.div`
  background-color: #eceff1;
  padding: 30px 15px;

  @media (min-width: 1024px) {
    padding: 30px 180px;
  }
`;
